import { useRef, useState } from 'react';
import { useStoreConfig } from '../context/StoreConfigContext.jsx';
import { readStoredValue, writeStoredValue } from '../lib/storage.js';
import '../styles/components/AnnouncementsStyle.css';

const TYPE_ICONS = {
  info: 'fa-circle-info',
  warning: 'fa-triangle-exclamation',
  success: 'fa-circle-check',
  danger: 'fa-circle-exclamation',
};

const dismissKey = (id) => `ann_dismissed_${id}`;

export function Announcements() {
  const { announcement } = useStoreConfig();
  const barRef = useRef(null);
  const [dismissedId, setDismissedId] = useState(null);

  if (!announcement) return null;


  const wasDismissedEarlier = Boolean(readStoredValue(dismissKey(announcement.id)));

  if (wasDismissedEarlier || dismissedId === announcement.id) return null;

  const handleDismiss = () => {
    writeStoredValue(dismissKey(announcement.id), '1');
    collapse(barRef.current, () => setDismissedId(announcement.id));
  };

  return (
    <div className="announcements-bar" ref={barRef}>
      <div className="announcement-card" data-type={announcement.type}>
        <i
          className={`fa-solid ${TYPE_ICONS[announcement.type] ?? TYPE_ICONS.info} announcement-icon`}
        />
        <p className="announcement-msg">{announcement.message}</p>
        <button
          type="button"
          className="announcement-dismiss"
          aria-label="Dismiss announcement"
          onClick={handleDismiss}
        >
          <i className="fa-solid fa-xmark" />
        </button>
      </div>
    </div>
  );
}


function collapse(element, onDone) {
  if (!element) {
    onDone();
    return;
  }

  const styles = getComputedStyle(element);
  const height = element.offsetHeight;

  element.style.boxSizing = 'border-box';
  element.style.overflow = 'hidden';
  element.style.height = `${height}px`;
  element.style.marginTop = styles.marginTop;
  element.style.marginBottom = styles.marginBottom;


  void element.offsetHeight;

  element.style.transition =
    'height 280ms ease, margin 280ms ease, padding 280ms ease, opacity 220ms ease, border-width 280ms ease';
  element.style.height = '0px';
  element.style.paddingTop = '0px';
  element.style.paddingBottom = '0px';
  element.style.borderTopWidth = '0px';
  element.style.borderBottomWidth = '0px';
  element.style.opacity = '0';
  element.style.marginTop = '0px';
  element.style.marginBottom = '0px';

  setTimeout(onDone, 300);
}
